import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_food_drink: FaireCategoryEntity = {
  token: "cat_food-drink",
  type: "category",
  name: "Food & drink",
  level: 1,
  href: "/category/food-drink",
  childCategoryTokens: [
    "cat_food-all",
    "cat_food-new-products",
    "cat_food-new-brands",
    "cat_food-bestsellers",
    "cat_food-snacks",
    "cat_food-beverages",
    "cat_food-gourmet",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
